(function () {
  'use strict';
  var box = document.getElementById('hbp-restock');
  var data = document.getElementById('hbp-restock-variants');
  if (!box || !data) return;
  var variants;
  try { variants = JSON.parse(data.textContent); } catch (_) { return; }
  var form = document.getElementById('hbp-restock-form');
  var email = document.getElementById('hbp-restock-email');
  var status = box.querySelector('[data-restock-status]');
  var button = form.querySelector('button[type="submit"]');
  var productForm = document.querySelector('main form[action*="/cart/add"], #MainContent form[action*="/cart/add"]');
  if (!productForm) return;
  productForm.insertAdjacentElement('afterend', box);
  var selected = null, busy = false, submitted = {};
  function update() {
    var input = productForm.querySelector('[name="id"]');
    var id = input && input.value || new URL(location.href).searchParams.get('variant') || String(variants[0] && variants[0].id);
    var next = variants.find(function (v) { return String(v.id) === String(id); });
    if (!next) { box.hidden = true; return; }
    if (!selected || selected.id !== next.id) {
      selected = next;
      status.textContent = submitted[next.id] ? 'You’re on the list for this item. We’ll email you when it returns.' : '';
    }
    box.hidden = next.available === true;
    button.disabled = busy || !!submitted[next.id];
  }
  form.addEventListener('submit', function (event) {
    event.preventDefault(); update();
    if (busy || !selected || selected.available || submitted[selected.id] || !form.reportValidity()) return;
    busy = true; button.disabled = true; status.textContent = 'Saving your request…';
    var variantId = selected.id;
    var payload = { data: { type: 'back-in-stock-subscription', attributes: {
      profile: { data: { type: 'profile', attributes: { email: email.value.trim().toLowerCase() } } }, channels: ['EMAIL']
    }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } } } };
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=XhRmbn', {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
      body: JSON.stringify(payload), signal: controller.signal
    }).then(function (response) {
      if (response.status !== 202) throw new Error('not_accepted');
      submitted[variantId] = true;
      if (selected.id === variantId) status.textContent = 'You’re on the list for this item. We’ll email you when it returns.';
    }).catch(function () {
      if (selected.id === variantId) status.textContent = 'We couldn’t confirm your request. Please try again.';
    }).finally(function () { clearTimeout(timeout); busy = false; update(); });
  });
  update();
  // Themes change the hidden variant input without consistently dispatching events.
  var timer = setInterval(update, 700);
  window.addEventListener('pagehide', function () { clearInterval(timer); }, { once: true });
})();
